import Markdown from "./Markdown";
export default Markdown;